import React, { useState } from 'react'
import { PropTypes } from 'prop-types'
import Icons from 'assets/icons';

const TableHeader = ({ title, button, isAttention }) => {

  const [show, setShow] = useState(false);

  const attention = () => {
    setShow(true)
  }
  return (
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center justify-content-between">
        <span className='heading-5 mr-3'>{title}</span>
        {isAttention && <>
          <Icons.attention
            size={20}
            onMouseEnter={() => attention()}
            onMouseLeave={() => setShow(false)}
            className='text-danger cursor-pointer'
          />
          {show && <div className="accordion-header-title-attention">  Kaydedilen fatura kalemlerinin ödeme yüzdeleri toplamı %100 değildir.</div>}  </>}

      </div>
      <div>{button && button}
      </div>
    </div>
  )
}
TableHeader.propTypes = {
  title: PropTypes.string,
  button: PropTypes.node
}
export default TableHeader